<div class="subscription-final-page" data-testid="dashboard-souscription-funnel-final">
  <img
    src="assets/svg/ressources/subscription-final.svg"
    alt=""
    srcset=""
    width="260px;"
    height="180.9px;"
  />
  <!-- Séquençage V2 — En V2, les progress in-flight sont WAITING_PACK_REGLEMENTAIRE /
       _ADEQUATION / _BS / IN_SEQUENCING (cf. PledgeProgressEnum ADR-024). Le titre legacy
       "Votre souscription est terminée." ne doit s'afficher que pour les états finaux. -->
  @if (
    progress &&
    progress !== 'WAITING_UNIVERSIGN_VALIDATION' &&
    progress !== 'WAITING_SIGNATURE_JURIDIC' &&
    progress !== 'WAITING_PACK_REGLEMENTAIRE' &&
    progress !== 'WAITING_PACK_ADEQUATION' &&
    progress !== 'WAITING_PACK_BS' &&
    progress !== 'IN_SEQUENCING'
  ) {
    <title>Votre souscription est terminée.</title>
  }
  @if (
    progress &&
    progress === 'WAITING_UNIVERSIGN_VALIDATION' &&
    signatureType === 'ELECTRONIC'
  ) {
    <title>
      Votre souscription est en attente de validation par universign.
    </title>
  }
  @if (
    progress &&
    progress === 'WAITING_SIGNATURE_JURIDIC' &&
    signatureType === 'ELECTRONIC'
  ) {
    <sub-title>
      Votre souscription est terminée, un premier lien de signature a été envoyé
      pour signer les documents juridiques. Un second lien de signature sera
      envoyé pour signer les documents de souscription 48h après la signature
      des documents juridiques.
    </sub-title>
  }
  <!-- Séquençage V2 — wording adapté à la cascade 3 packs (Réglementaire → Adéquation → BS).
       Un seul pack envoyé à la fois, le suivant l'est automatiquement après signature
       (ou après délai pour IN_SEQUENCING). -->
  @if (
    progress &&
    signatureType === 'ELECTRONIC' &&
    (progress === 'WAITING_PACK_REGLEMENTAIRE' ||
      progress === 'WAITING_PACK_ADEQUATION' ||
      progress === 'WAITING_PACK_BS' ||
      progress === 'IN_SEQUENCING')
  ) {
    <!-- Séquençage V2 — en IN_SEQUENCING rien n'est chez Universign : le pack précédent
         est signé et le suivant attend son créneau. Titre distinct du cas WAITING_PACK_*. -->
    @if (progress === 'IN_SEQUENCING') {
      <title>Votre souscription est en attente d'envoi du prochain pack.</title>
    } @else {
      <title>Votre souscription est en cours de signature.</title>
    }
    <sub-title>
      <!-- Wording adapté au scope du pledge : pas de mention "Pack BS" si LEGAL_ONLY, etc.
           Les packs restants sont calculés depuis les packs reçus du backend (cf.
           extractRemainingPackTypes), pas écrits en dur. -->
      @if (v2GroupedSendSentence) {
        {{ v2GroupedSendSentence }}
      } @else if (
        progress === 'WAITING_PACK_REGLEMENTAIRE' && v2WaitingSharedSignature
      ) {
        Le Pack Réglementaire reprend des documents en cours de signature sur
        une autre souscription. Les packs seront envoyés en signature une fois
        cette signature obtenue.
      } @else if (progress === 'WAITING_PACK_REGLEMENTAIRE') {
        Le Pack Réglementaire a été envoyé en signature électronique.
        @if (hasRemainingAdequation && hasRemainingBs) {
          Les Packs Adéquation et BS seront envoyés automatiquement après chaque
          signature.
        } @else if (hasRemainingAdequation) {
          Le Pack Adéquation sera envoyé automatiquement après sa signature.
        } @else if (hasRemainingBs) {
          Le Pack BS sera envoyé automatiquement après sa signature.
        }
      } @else if (progress === 'WAITING_PACK_ADEQUATION') {
        Le Pack Adéquation a été envoyé en signature électronique.
        @if (hasRemainingBs) {
          Le Pack BS sera envoyé après sa signature.
        }
      } @else if (progress === 'WAITING_PACK_BS') {
        Le Pack BS a été envoyé en signature électronique.
      } @else if (progress === 'IN_SEQUENCING') {
        <!-- Séquençage V2 — wording aligné sur albr-pro : nom du pack parqué en
             WAITING_SEQUENCING + date d'envoi (sequencingReleaseAt, heure de Paris).
             Fallback générique si le pack/la date n'est pas disponible. -->
        @if (v2SequencedPackLabel && v2SequencedReleaseAtLabel) {
          Le pack précédent a déjà été signé. En attente d'envoi du
          {{ v2SequencedPackLabel }} le {{ v2SequencedReleaseAtLabel }}.
        } @else if (v2SequencedPackLabel) {
          Le pack précédent a déjà été signé. Le {{ v2SequencedPackLabel }}
          sera envoyé automatiquement après le délai de séquençage.
        } @else {
          Pack précédent signé. Le pack suivant sera envoyé après le délai de
          séquençage.
        }
      }
    </sub-title>
  }

  @if (
    progress &&
    progress !== 'WAITING_UNIVERSIGN_VALIDATION' &&
    signatureType === 'ELECTRONIC'
  ) {
    <div>
      @if (organizationESignatureUrl) {
        <sub-title>Lien vers la signature électronique : </sub-title>
      }
      @if (organizationESignatureUrl) {
        <sub-title [style]="subTitleStyle">
          <a (click)="copyToClipboard()" class="organizationESignatureUrl">
            {{ organizationESignatureUrl }}
            <i
              [attr.title]="'Copier  l\'URL dans le presse-papiers'"
              class="fa fa-copy"
            ></i>
          </a>
        </sub-title>
      }
      @if (
        !organizationESignatureUrl &&
        !hasPledgeContainsFinancileProduct
      ) {
        <sub-title [style]="subTitleStyle">
          vous pouvez retrouver les documents correspondants dans la page
          Document
        </sub-title>
      }
    </div>
  }

  @if (
    !organizationESignatureUrl &&
    hasPledgeContainsFinancileProduct &&
    signatureType === 'ELECTRONIC'
  ) {
    <div class="box-info-financile">
      <p>
        La génération du bulletin de souscription et l'envoi en signature
        électronique ce fait uniquement par le BO depuis le TDV. Veuillez vous
        rendre sur le TDV afin de valider l'ensemble des pièces justificatives
        et de transmettre la souscription au BO.
      </p>
      <pr-button
        class="mt-1"
        size="lg"
        type="button"
        display="neutral"
        data-testid="dashboard-souscription-funnel-final-tdv-link"
        (onClick)="generatePledgeProductTdvLink()"
        label="Lien vers TDV"
      />
    </div>
  }

  @if (signatureType === 'PAPER') {
    <div class="box-info-financile">
      <p>
        Vous avez choisir la signature papier. <br />
        Veuillez vous rendre sur le TDV afin de valider l'ensemble des pièces
        justificatives et de transmettre la souscription au BO.
      </p>
      <pr-button
        class="mt-1"
        size="lg"
        type="button"
        display="neutral"
        data-testid="dashboard-souscription-funnel-final-tdv-link"
        (onClick)="generatePledgeProductTdvLink()"
        label="Lien vers TDV"
      />
    </div>
  }

  @if (
    progress &&
    progress === 'WAITING_UNIVERSIGN_VALIDATION' &&
    signatureType === 'ELECTRONIC'
  ) {
    <div>
      <sub-title
        >Vous recevrez un mail de confirmation dès que la validation sera
        effectuée.
      </sub-title>
    </div>
  }

  <pr-button
    class="mt"
    size="lg"
    type="button"
    display="neutral"
    data-testid="dashboard-souscription-funnel-final-overview"
    (onClick)="navigateToOverview()"
    label="Retourner à la synthèse"
  ></pr-button>
</div>
<!-- <pr-button
size="lg"
type="button"
label="Question précédente"
icon="arrow_left"
(onClick)="prev()"
></pr-button> -->
